var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 546,
    viewBox: "0 0 1440 546",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.5 119.654C37.5 166.154 3 219.653 -23 326.153L-43 591.881L665 650.881C861.5 673.047 1287.4 712.681 1419 693.881C1550.6 675.081 1536.5 576.321 1563 510.654C1615.83 333.82 1746 87.3832 1538.5 24.654C1253.63 -61.4661 1085.5 102.154 1005 147.154C924.5 192.155 794.5 216.154 686.5 191.654C578.5 167.154 501.199 138.827 402.5 102.654C307 67.6543 209.911 54.8049 109.5 119.654Z",
    fill: "#0071CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueWave);
export default __webpack_public_path__ + "static/media/blue_wave.68f2155eb29e24e5b65bb8ab6b65d4e4.svg";
export { ForwardRef as ReactComponent };